import AstroMapImage from "@/assets/img/modal/astro_map.webp"
import { ASTRO_MAP_REPORT_MODAL_V2_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV2, type ReportPromoCopyV2 } from "./report-promo-modal-v2"

const COPY: ReportPromoCopyV2 = {
  reportId: ReportIds.AstroMap,
  planId: ASTRO_MAP_REPORT_MODAL_V2_PLAN_ID,
  title: "Get Your Astro Map",
  description:
    "Discover the places that may support your love, career, money, calm, and personal growth",
  image: AstroMapImage,
}

export function ReportAstroMapModalV2(props: AppModalComponentProps) {
  return <ReportPromoModalV2 {...props} copy={COPY} />
}
